import type { FunctionComponent } from 'react';

import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { Icon } from '../icon/icon';

import styles from './star-rating.module.scss';

const style = createStyleHelper(styles, 'star-rating');

export interface IStarRatingProps {
    className?: string;
    ratingPercent: number;
}

export const StarRating: FunctionComponent<IStarRatingProps> = ({ className, ratingPercent }) => {
    return (
        <div className={createClassName([className, style()])}>
            <div className={style('star-ratings-css')}>
                <div className={style('filled-stars')} style={{ width: `${ratingPercent}%` }}>
                    <Icon name={'star-solid'} inline />
                    <Icon name={'star-solid'} inline />
                    <Icon name={'star-solid'} inline />
                    <Icon name={'star-solid'} inline />
                    <Icon name={'star-solid'} inline />
                </div>
                <div className={style('empty-stars')}>
                    <Icon name={'star'} inline />
                    <Icon name={'star'} inline />
                    <Icon name={'star'} inline />
                    <Icon name={'star'} inline />
                    <Icon name={'star'} inline />
                </div>
            </div>
        </div>
    );
};
